<span
  [ngClass]="activeStyle(active)"
  class="cursor-pointer select-none truncate rounded-full px-3 py-1 text-sm leading-none transition duration-300"
>
  <ng-content></ng-content>
</span>
